// extracted by mini-css-extract-plugin
module.exports = {"root":"contato_root__HM-xq","title":"contato_title__2YJJm","form":"contato_form__23U3y"};